module.exports = __webpack_public_path__ + "assets/img/yinxingfeipang2.7a5182dc.png";